export const indexCompaniesPath: string = "/companies";
export const newCompaniesPath: string = "/companies/new";
export const editCompaniesPath: string = "/companies/:id/edit";
export const showCompaniesPath: string = "/companies/:id";
export const showCompaniesPathCreator = (id: number|string): string => `/companies/${id}`
